export function scrollTop() {
    $(".back-to-top").on("click", function () {
        $("html, body").animate({ scrollTop: 0 }, 1000);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/scrollTop.js